module.exports = __webpack_public_path__ + "img/icon.3ee54a2e.svg";